<template>
		<v-layout row justify-center>
			<v-flex>
				<v-card color="background elevation-0">
					<v-card-text>
						<v-stepper v-model="step" vertical class="background elevation-0">

							<v-stepper-step editable :complete="step > 1" step="1" color="primary color--text">
								Choix du répertoire
								<small>Veuillez choisir un dossier</small>
							</v-stepper-step>
							<v-stepper-content step="1" class="pt-0">
								<v-btn @click="showExplorer = true" small color="primary color--text">
									<v-icon left>folder</v-icon>
									Choisir un dossier
								</v-btn>
								<v-text-field label="Répertoire selectionné" readonly v-model="selectedDir.path" />
								<v-btn
									color="primary color--text"
									:disabled="!selectedDir.path"
									@click="step = 2">
									Continuer
								</v-btn>
							</v-stepper-content>

							<v-stepper-step
								:editable="Object.keys(selectedDir).length > 0"
								:complete="step > 2"
								color="primary color--text"
								step="2">
								Choix des informations nécessaires
							</v-stepper-step>
							<v-stepper-content step="2" class="pt-0">
								<v-flex xs12>
									<v-card-text>
										<v-flex>
											<v-text-field
												:loading="suifaInfos.loading"
												v-model="suifaRef"
												name="name"
												label="Référence suifa"
												id="id"
												@input="getBehiveAssetInfo(suifaRef)">
												<v-tooltip
													slot="append"
													bottom>
													<v-btn
														@click="getBehiveAssetInfo(suifaRef)"
														icon
														small
														:disabled="suifaInfos.loading"
														slot="activator">
														<span v-if="suifaInfos.loading">
															<v-progress-circular
																indeterminate
																:size="35"
																:width="5">
															</v-progress-circular>
														</span>
														<span v-else>
															<v-icon>
																youtube_searched_for
															</v-icon>
														</span>
													</v-btn>
													Get data from Behive/Suifa
												</v-tooltip>
											</v-text-field>

											<div v-if="errors">
												<div v-for="error in errors" :key="error.id">
													<p class="error--text">{{ error }}</p>
												</div>
											</div>

											<div v-if="suifaInfos.data && suifaInfos.data.t_aux_proprio">
												<p v-if="suifaInfos.data.t_aux_proprio.t_libelle || suifaInfos.data.t_aux_proprio.t_auxiliaire" class="mb-1">
													<strong class="primary--text">Ayant droit :</strong>
													{{ suifaInfos.data.t_aux_proprio.t_libelle }} - ({{ suifaInfos.data.t_aux_proprio.t_auxiliaire }})
												</p>
												<p class="m-0">
													<strong class="primary--text">Asset :</strong>
													<v-chip small label v-if="suifaInfos.data.type_sup.code_type_sup" class="mx-0">
														{{ suifaInfos.data.type_sup.code_type_sup }}
													</v-chip>
													<span v-if="suifaInfos.data.titre.titre_princ" class="mb-1">
														{{ suifaInfos.data.titre.titre_princ }}
													</span>
													<strong>
														<span v-if="suifaInfos.data.asset_size && String(suifaInfos.data.asset_size).length < 10" class="mb-1">
															- {{ $weight.bitRoundToTwo(suifaInfos.data.asset_size, 2) }} Mo
														</span>
														<span v-else-if="suifaInfos.data.asset_size" class="mb-1">
															- {{ $weight.bitRoundToTwo(suifaInfos.data.asset_size, 3) }} Go
														</span>
													</strong>
												</p>
												<p v-if="suifaInfos.data.type_sup.code_type_sup" class="mb-1">
													<strong class="primary--text">Contrat :</strong>
													<span v-if="this.localHasContract">Oui</span>
													<span v-else>Non</span>
												</p>
											</div>

										</v-flex>
									</v-card-text>
								</v-flex>
								<v-btn
									color="primary color--text"
									:disabled="errors.length > 0 || !suifaInfos.data"
									@click="step = 3">
									Continuer
								</v-btn>
							</v-stepper-content>

							<v-stepper-step
								color="primary color--text"
								step="3">
								Confirmation
								<small>Veuillez vérifier les informations entrées</small>
							</v-stepper-step>
							<v-stepper-content step="3" class="pt-0">
								<strong>Répertoire sélectionné :</strong> {{ selectedDir.path }}
								<br/>
								<strong>Informations entrées :</strong>
								<div v-if="suifaInfos.data && suifaInfos.data.t_aux_proprio && suifaInfos.data.titre && suifaInfos.data.programme.type_prgm">
									<ul>
										<li>
											<strong>T aux : </strong>{{ suifaInfos.data.t_aux_proprio.t_libelle }}
										</li>
										<li>
											<strong>Titre : </strong>{{ suifaInfos.data.titre.titre_princ }}
										</li>
										<li>
											<strong>Type programme : </strong>{{ suifaInfos.data.programme.type_prgm.lib_type_prgm }}
										</li>
									</ul>
								</div>
								<div v-if="$user.isAdmin()">
									<tree-view
										v-if="manifest"
										:data="manifest"
										:options="{rootObjectKey: 'manifest'}">
									</tree-view>
									<br/>
								</div>

								<div v-if="!errors.length && suifaInfos.data">
									<hr>
									<v-layout class="mt-4" justify-end>
										<v-flex xs4>
											<v-select
												dense
												flat
												prepend-inner-icon="archive"
												:items="stockageList"
												v-model="storageType"
												label="Type de stockage"/>
										</v-flex>

										<v-spacer></v-spacer>

										<v-flex shrink>
											<v-switch
												class="switch-label"
												color="primary"
												v-model="removeSource"
												label="Supprimer la source"/>
										</v-flex>
									</v-layout>

									<v-layout justify-end>
										<v-btn class="mr-0" :disabled="disableSubmitButton" @click="submit(); $emit('close')" color="primary color--text" :loading="submitLoading">Envoyer</v-btn>
									</v-layout>
								</div>
							</v-stepper-content>

						</v-stepper>
					</v-card-text>
				</v-card>
			</v-flex>

			<Explorer
				v-if="showExplorer"
				:shortcuts="explorer.shortcuts"
				:assetType="explorer.assetType"
				:multiselect="false"
				@close="showExplorer = false"
				@selectedAssets="onSelectDir($event)">
				<h3 slot="header">Asset Select for Maestro ingester</h3>
			</Explorer>

		</v-layout>

</template>

<script>
import Explorer from '@/components/modal_explorer.vue'

export default {
	components: {
		Explorer
	},
	props: ['param', 'wf_data'],
	data () {
		return {
			behiveCat: ['data'],
			stockageList: [
				{ value: 'catalog', text: 'Catalog' },
				{ value: 'maestro', text: 'Maestro' }
			],
			storageType: { value: 'catalog', text: 'Catalog' },
			suifaRef: '',
			suifaInfos: {
				data: null,
				loading: false
			},
			manifest: null,
			jobTypes: ['FDVD', 'FBD'],
			errors: [],
			submitLoading: false,
			step: 1,
			showExplorer: false,
			explorer: {
				shortcuts: [
					{ text: '1305j552 - Bluray', value: '//1305j552/dvd/ARCHIVAGE/BD/1_A_FAIRE' },
					{ text: '1305j552 - Dvd', value: '//1305j552/dvd/ARCHIVAGE/DVD/1_A_FAIRE/3_SUR_SERVEUR' }
				],
				assetType: 'folder'
			},
			localHasContract: false,
			selectedDir: [],
			removeSource: false
		}
	},
	computed: {
		disableSubmitButton () {
			if (this.suifaInfos.loading) {
				return true
			}
			return false
		}
	},

	methods: {
		onSelectDir (evt) {
			evt.path = this.$paths.UNCToMaestro(evt.path)
			this.selectedDir = evt
		},

		getTAuxContract (tAux) {
			return new Promise((resolve, reject) => {
				this.$apiPublic.contract_search(tAux)
					.then(response => {
						resolve(response)
					})
					.catch(error => {
						console.error(error)
						reject(error)
					})
			})
		},

		getAssetInfo (ref) {
			return new Promise((resolve, reject) => {
				let params = {
					ref_materiel: ref,
					per_page: 100
				}
				this.$apiPublic.material_search(params, true)
					.then(response => {
						resolve(response)
					})
					.catch(err => {
						console.error(err)
						reject(err)
					})
			})
		},

		async getAlreadyIngestedRef (suifa_ref, category) {
			return new Promise((resolve, reject) => {
				let params = {
					'type_sup_id': 1010,
					'suifa_ref': suifa_ref,
					'category': category
				}
				this.$apiPublic.material_search(params)
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						console.error(err)
						reject(err)
					})
			})
		},

		async getBehiveAssetInfo (ref) {
			this.suifaInfos.loading = true
			this.storageType = { value: 'catalog', text: 'Catalog' }
			let refSuifa = ref.replace(/(_|-|\/|\\)/g, '/')

			// replaces spaces and tabs
			refSuifa = refSuifa.replace(/(\t|\s+)/g, '')

			let refSuifaRegEx = /[0-9]{2}\/[0-9]{2}\/[a-zA-Z0-9]{4}/g

			// if (ref.match(refSuifaRegEx))
			if (refSuifa.match(refSuifaRegEx)) {
				let hotRef = await this.getAlreadyIngestedRef(refSuifa, 'hot')
				let catalogRef = await this.getAlreadyIngestedRef(refSuifa, 'catalog')
				let jobExists = hotRef.concat(catalogRef)

				if (jobExists.length) {
					// if job exists in maestro
					this.suifaInfos.loading = false
					this.errors = [`La référence '${this.suifaRef}' a déjà été ingestée (ou en cours d'ingest) par Maestro.`]
				} else {
					let activeAssets
					this.getAssetInfo(refSuifa)
						.then(response => {
							activeAssets = response.filter(asset => {
								return this.behiveCat.includes(asset.behive_category)
							})
							// if no active assets
							if (response.length === 0) {
								this.errors = []
								this.manifest = null
								this.errors.push(
									'Pas d\'asset en catalogue ou stockage chaud pour cette référence. ' + `${this.suifaRef}`
								)
								this.suifaInfos.data = {...response}
								this.suifaInfos.loading = false
								return
							}
							return activeAssets
						})
						.then(response => {
							// reindex asset before getting infos
							return response.map(asset => {
								this.$ApiNexus.reindex_asset(asset.mat_id)
							})
						})
						.then(response => {
							// wait some time because reindex takes time
							return new Promise((resolve) => {
								setTimeout(() => {
									resolve()
								}, 1500)
							})
						})
						.then(response => this.getAssetInfo(refSuifa))
						.then(response => {
							activeAssets = response.filter(asset => {
								return this.behiveCat.includes(asset.behive_category)
							})
							return activeAssets
						})
						.then(response => {
							// if we find active assets
							if (response.length > 0) {
								for (let activeAsset of response) {
									if (this.jobTypes.includes(activeAsset.type_sup.code_type_sup)) {
										this.manifest = null
										this.suifaInfos.data = {...activeAsset}
										this.suifaInfos.loading = false
										this.errors = []
										this.getTAuxContract(this.suifaInfos.data.t_aux_proprio.t_auxiliaire)
											.then(contract => {
												// if client has catalog subscription
												if (contract) {
													if (contract.results.length > 0) {
														let hasContract = contract.results[0].has_storage_catalog
														if (hasContract) {
															this.localHasContract = true
															this.storageType = this.stockageList[0]
														}
													} else {
														this.localHasContract = false
														this.storageType = this.stockageList[1]
													}
												}
											})

										break
									} else if (activeAsset.type_sup && !this.jobTypes.includes(activeAsset.type_sup.code_type_sup)) {
										this.errors = []
										this.manifest = null
										this.errors.push(`Type d'asset non pris en charge. (${activeAsset.type_sup.code_type_sup})`)
										this.suifaInfos.data = {...activeAsset}
										this.suifaInfos.loading = false
										// if activeAsset has not cpls array
									}
								}
							// if no active assets
							} else {
								this.errors = []
								this.manifest = null
								this.errors.push(
									'Pas d\'asset en catalogue ou stockage chaud pour cette référence. ' + `${this.suifaRef}`
								)
								this.suifaInfos.data = null
								this.suifaInfos.loading = false
							}
						})
						.catch(error => {
							console.error(error)
							this.suifaInfos.loading = false
						})
				}
			}
		},

		submit () {
			this.submitLoading = true
			let parameters = {}
			this.wf_data.parameters.map(param => {
				if (param.name === 'Suifa Ref' || param.name === 'suifa_ref') {
					parameters[param.name] = this.suifaRef
				} else if (param.name === 'Directory' || param.name === 'directory') {
					parameters[param.name] = this.selectedDir.path + '/'
				} else if (param.name === 'Server Storage' || param.name === 'server_storage') {
					parameters[param.name] = this.storageType.value
				} else if (param.name === 'Remove Source' || param.name === 'remove_source') {
					parameters[param.name] = this.removeSource
				}
			})
			let data = {
				jd_id: window.appConfig.maestro_wf['asset dvd/bluray ingest'].id,
				parameters: parameters
			}
			this.$emit('submit')
			this.$ApiMaestro.jobrequest_create(data)
				.then(response => {
					this.submitLoading = false
					this.$emit('maestroFormSent', response)
				})
				.catch(error => {
					console.error(error)
					this.$emit('maestroFormErrorSending', error.response)
					this.submitLoading = false
				})
		}
	},
	mounted () {
		if (this.param) {
			if (this.param.type.indexOf('folder') > -1) {
				this.selectedDir = { path: this.param.value + '/' }
			}
		}
	}
}
</script>

<style scoped lang="stylus">
.v-input--selection-controls.v-input.switch-label
	label.v-label
		margin: 0 !important

.v-input--switch.switch-label
	max-width: 100% !important
</style>



// WEBPACK FOOTER //
// src/pages/maestro/jobs/launcher/job_launcher_form_dvd_bd.vue